import React from 'react';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import { Image } from 'antd';
import './index.less';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PageLayout from '../../Components/pageLayout';

import honors1 from '../../static/honors1.webp'
import honors2 from '../../static/honors2.webp'
import honors3 from '../../static/honors3.webp'
import honors4 from '../../static/honors4.jpg'
import honors5 from '../../static/honors5.jpg'
import honors6 from '../../static/honors6.jpg'
import honors7 from '../../static/honors7.jpg'
import honors8 from '../../static/honors8.png'

const Honors: React.FC = () => {
    const history = useHistory();

    // 荣誉图片数据
    const honors = [
        { id: 6, src: honors6, alt: '社会组织评定等级铜牌' },
        { id: 7, src: honors7, alt: '中基透明指数FTI2025证书（浙江省）' },
        { id: 8, src: honors8, alt: '社会组织评定等级证书' },
        { id: 5, src: honors5, alt: '中基透明指数FT12023证书' },
        { id: 1, src: honors1, alt: '荣誉图片1' },
        { id: 2, src: honors2, alt: '荣誉图片2' },
        { id: 3, src: honors3, alt: '荣誉图片3' },
        { id: 4, src: honors4, alt: '荣誉图片4' }
        
    ];

    // 轮播配置
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1000,
    };

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>荣誉认证</h1>
                <div className='honors-carousel'>
                    <Slider {...settings}>
                        {honors.map((honor) => (
                            <div key={honor.id} className='honor-slide'>
                                <Image src={honor.src} alt={honor.alt} preview={{ src: honor.src }} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        } />
    );
};

export default Honors;